const getBodyScrollTop = {
  el: null,
  get top () {
    this.el = document.scrollingElement || document.documentElement
    return this.el.scrollTop
  },
  set top (val) {
    this.el = document.scrollingElement || document.documentElement
    this.el.scrollTop = val
  }
}
const shuffleArray = ([...array]) => {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1))
    if (i === j) continue
    var k = array[i]
    array[i] = array[j]
    array[j] = k
  }
  return array
}
export { getBodyScrollTop, shuffleArray }



// WEBPACK FOOTER //
// ./src/bin/helpers.js